import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-[rgba(255,255,255,.06)] py-[44px] text-center" data-id="element-155">
      <div className="container" data-id="element-156">
        <img src="https://i.postimg.cc/L572LLmP/Group-13-min.png" alt="Código Oscuro" className="h-[30px] mx-auto mb-4 opacity-60 block" data-id="element-157" />
        <p className="text-[10px] text-[rgba(255,255,255,.22)] leading-[1.9] max-w-[680px] mx-auto mb-1.5" data-id="element-158">
          <a href="#" className="text-[rgba(255,255,255,.3)] no-underline transition-colors duration-200 hover:text-dorado" data-id="element-159">
            Términos de Uso
          </a>{' '}
          &nbsp;·&nbsp;
          <a href="#" className="text-[rgba(255,255,255,.3)] no-underline transition-colors duration-200 hover:text-dorado" data-id="element-160">
            Política de Privacidad
          </a>{' '}
          &nbsp;·&nbsp;
          <a href="#" className="text-[rgba(255,255,255,.3)] no-underline transition-colors duration-200 hover:text-dorado" data-id="element-161">
            Contacto
          </a>
        </p>
        <br data-id="element-162" />
        <p className="text-[10px] text-[rgba(255,255,255,.22)] leading-[1.9] max-w-[680px] mx-auto mb-1.5" data-id="element-163">
          Este sitio no pertenece ni está respaldado por Facebook, Inc. FACEBOOK
          es una marca registrada de Meta Platforms, Inc.
        </p>
        <p className="text-[10px] text-[rgba(255,255,255,.22)] leading-[1.9] max-w-[680px] mx-auto mb-1.5" data-id="element-164">
          Los resultados individuales pueden variar. Este producto no garantiza
          resultados específicos.
        </p>
        <p className="text-[10px] text-[rgba(255,255,255,.22)] leading-[1.9] max-w-[680px] mx-auto mt-2.5" data-id="element-165">
          © CÓDIGO OSCURO – Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}